export const PERMISSIONS = {
  ADMIN: "admin",
  USERS_MANAGEMENT: "users_management",
  SUBMIT_APPLICATIONS: "submit_applications",
  CALLS_FOR_APPLICATIONS: "calls_for_applications",
  VIEW_CALLS_FOR_APPLICATIONS: "view_calls_for_applications",
  RETURN_APPLICATIONS: "return_applications",
  VIEW_APPLICATIONS: "view_applications",
  SUBMITTED_APPLICATIONS: "submitted_applications",
  SAVE_APPLICATIONS: "save_applications",
  VIEW_CALLS_FOR_APPLICATIONS_WIDGETS: "view_calls_for_applications_widgets",
  FEEDBACK_MANAGEMENT: "feedback_management",
  TEMPLATE_FILES_MANAGEMENT: "template_files_management",
  DOWNLOAD_NRB_USER_MANUAL: "download_nrb_user_manual",
  SAVE_REPORTS: "save_reports",
  VIEW_REPORTS: "view_reports",
  SUBMIT_REPORTS: "submit_reports",
  MANAGE_SUBMITTED_REPORTS: "manage_submitted_reports",
  DELETE_CALLS_FILE: "delete_calls_file",
  VIEW_AWARDED_APPLICATIONS: "view_awarded_applications",
  CHANGE_STATUS_TO_DISBURSED: "change_status_to_disbursed",
  MANAGE_CONTACT_INFORMATION: "manage_contact_information",
  VIEW_CONTACT_INFORMATION: "view_contact_information",
};
